import React, { Component } from "react";
import { Link } from "react-router-dom";
import apiClient from "../lib/apiClient";

class Jukebox extends Component {
  state = {
    songs: [],
    isLoading: true
  };

  async componentDidMount() {
    const songs = await apiClient.getAllSongs();
    return this.setState({songs, isLoading: false})
  }

  render() {
    const { songs, isLoading } = this.state;
    const compare = (a, b) => {
      if ( a.pageNum < b.pageNum ){
          return -1;
        }
        if ( a.pageNum > b.pageNum ){
          return 1;
        }
        return 0;
    }

    if (isLoading) {
      return <p>Loading...</p>
    }

    return (
      <div className="flex flex-col items-center pt-10 main h-2/3">
        <p className="text-2xl pb-10">Els teus temes</p>
        <div className="w-80">
          {songs.sort(compare).map((song, index) => {
            return <div key={index} className="flex justify-between text-sm">
              <p>{song.name} - {song.artist} | Pàg. {song.pageNum}  </p>
                <Link to={`/${song._id}`}><button className="text-blue-600 underline">Editar</button></Link>
            </div>
          })}
        </div>
    </div>
  )
}
}

export default Jukebox;